// Konfiguracja aplikacji — wartości wstrzykiwane przy buildzie z plików .env.<locale>
// (vue-cli udostępnia tylko zmienne z prefiksem VUE_APP_).
export const Const = Object.freeze({
    LANG: process.env.VUE_APP_LANG,
    API_HOST: process.env.VUE_APP_API_HOST_URL,
    WEB_HOST: process.env.VUE_APP_WEB_PAGE_HOST_URL,
    MEDIA_HOST: process.env.VUE_APP_MEDIA_HOST_URL,
    // Klucz TinyMCE Cloud — do nadpisania przez VUE_APP_TINYMCE_KEY; ogranicz
    // klucz do domen paneli w panelu TinyMCE, bo i tak trafia do bundla.
    TINYMCE_KEY: process.env.VUE_APP_TINYMCE_KEY || 'jdsjwlv71ngv4ngm4fca30grz3lu6w833qma1br216ewfsqh',
    MODE_NEW: 'new',
    MODE_EDIT: 'edit',
})
